import React, { useState } from "react";
import "./Restaurant.css";

import ajaoRestaurant from "../../../assets/restaurant_images/ajao_restaurant.jpg";
import enuguBar from "../../../assets/restaurant_images/enugu_bar.jpg";
import guzapeBar from "../../../assets/restaurant_images/guzape_bar.jpg";
import lekkiRestaurant from "../../../assets/Lekki_phase1_hotel_images/restuarant/lekki_phase1_restaurant.JPEG";
import ogidiRestaurant from "../../../assets/restaurant_images/ogidi_restaurant.jpg";

const restaurants = [
  {
    id: 1,
    name: "Ajao Restaurant",
    location: "Ajao Estate, Lagos",
    tagline: "Local & Fast Food",
    description:
      "Quick service meets quality — enjoy freshly prepared meals for every taste.",
    amenities: ["Nigerian", "Continental", "Fast Food", "Takeout"],
    image: ajaoRestaurant,
  },
  {
    id: 2,
    name: "Enugu Bar & Grill",
    location: "Enugu",
    tagline: "Bar & Grill",
    description:
      "Relaxed vibes, cold drinks, and perfectly grilled meals in the heart of Enugu.",
    amenities: ["Grill", "Cocktails", "Live Music", "Outdoor Seating"],
    image: enuguBar,
  },
  {
    id: 3,
    name: "Guzape Bar & Lounge",
    location: "Guzape, Abuja",
    tagline: "Grill & Cocktails",
    description:
      "Unwind with premium cocktails, grilled delicacies, and breathtaking city views.",
    amenities: ["Premium Bar", "Grill", "Lounge", "Rooftop"],
    image: guzapeBar,
  },
  {
    id: 4,
    name: "Lekki Phase 1 Restaurant",
    location: "Lekki Phase 1, Lagos",
    tagline: "Fine Dining Experience",
    description:
      "An elegant dining experience offering continental and Nigerian cuisine in a sophisticated setting.",
    amenities: ["Fine Dining", "Wine Bar", "Private Events", "Valet"],
    image: lekkiRestaurant,
  },
  {
    id: 5,
    name: "Ogidi Restaurant",
    location: "Ogidi, Anambra",
    tagline: "Nigerian & Continental",
    description:
      "Experience authentic Nigerian delicacies and continental dishes in a warm, elegant setting.",
    amenities: ["Nigerian", "Continental", "Buffet", "Private Dining"],
    image: ogidiRestaurant,
  },
];

const Restaurant = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleNext = () => {
    setActiveIndex((prev) => (prev + 1) % restaurants.length);
  };

  const handlePrev = () => {
    setActiveIndex((prev) => (prev - 1 + restaurants.length) % restaurants.length);
  };

  const handleCardClick = (index) => {
    if (index !== activeIndex) {
      setActiveIndex(index);
    }
  };

  return (
    <section className="deck">
      {/* Dynamic background */}
      <div
        className="deck__bg"
        style={{
          backgroundImage: `url(${restaurants[activeIndex].image})`,
        }}
      />
      <div className="deck__overlay" />

      <div className="deck__container">
        {/* Header */}
        <div className="deck__header">
          <h2 className="deck__heading">
            Our <span>Restaurants</span>
          </h2>
          <div className="deck__divider" />
          <p className="deck__desc">
            Discover a world of flavors across our exclusive dining destinations.
          </p>
        </div>

        {/* Card Stack */}
        <div className="deck__stack-area">
          {/* Navigation Arrows */}
          <button className="deck__arrow deck__arrow--left" onClick={handlePrev}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>

          <div className="deck__stack">
            {restaurants.map((restaurant, index) => {
              const offset = (index - activeIndex + restaurants.length) % restaurants.length;
              const isActive = offset === 0;
              const isBehind = offset > 0;

              // Fan rotation: cards behind fan left/right alternately
              const rotation = isActive
                ? 0
                : offset % 2 === 1
                ? -offset * 12
                : offset * 12;

              return (
                <div
                  key={restaurant.id}
                  className={`deck__card ${isActive ? "deck__card--active" : ""} ${
                    isBehind ? "deck__card--behind" : ""
                  }`}
                  style={{
                    "--offset": offset,
                    "--rotation": rotation,
                    zIndex: restaurants.length - offset,
                  }}
                  onClick={() => handleCardClick(index)}
                >
                  <div className="deck__card-image">
                    <img src={restaurant.image} alt={restaurant.name} />
                  </div>
                  <div className="deck__card-content">
                    <span className="deck__card-location">{restaurant.location}</span>
                    <h3 className="deck__card-name">{restaurant.name}</h3>
                    <span className="deck__card-tagline">{restaurant.tagline}</span>
                    {isActive && (
                      <>
                        <p className="deck__card-desc">{restaurant.description}</p>
                        <div className="deck__card-amenities">
                          {restaurant.amenities.map((amenity) => (
                            <span key={amenity} className="deck__card-amenity">{amenity}</span>
                          ))}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          <button className="deck__arrow deck__arrow--right" onClick={handleNext}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Restaurant;
